<section class="section-next-match zoom-scope" *ngIf="matchesArr.length > 0 && styles" [ngStyle]="styles">
    <div class="wrapper-next-match p-4 h-100 w-100">
        <!-- <h1 class="section-title-mobile">Próximos confrontos</h1> -->
        <div class="row h-100 align-items-center w-100">
            <!-- Left column spacer for background image content -->
            <div class="col-lg-6 d-none d-lg-block"></div>

            <!-- Right column for match info -->
            <div class="col-12 col-lg-6">
                <div id="confronto" class="carousel slide" data-bs-ride="true">

                    <ol class="carousel-indicators" *ngIf="showIndicators">
                        <li *ngFor="let item of matchesArr; let i = index" data-bs-target="#confronto" [attr.data-bs-slide-to]="i"
                            [class.active]="i === 0"></li>
                    </ol>

                    <div class="carousel-inner p-1 p-md-3">
                        <ng-container *ngFor="let item of matchesArr; let i = index">
                            <div class="carousel-item" [class.active]="i === 0">

                                <div class="championship-info text-center mb-4">
                                    <span class="championship-text">
                                        {{item.championship}}
                                    </span>
                                </div>

                                <div class="match d-flex mb-4 justify-content-center align-items-center">
                                    @if (item.team1) {
                                        <div class="team px-2 px-sm-3 px-md-4">
                                            <img src="{{item.team1.src}}" alt="team 1" class="team-logo">
                                            <div class="club-name mt-2">
                                                <span>
                                                    {{item.team1.name}}
                                                </span>
                                            </div>
                                        </div>
                                    }
                                    <div class="versus mx-2 align-content-center">
                                        <span>X</span>
                                    </div>
                                    @if (item.team2) {
                                        <div class="team px-2 px-sm-3 px-md-4">
                                            <img src="{{item.team2.src}}" alt="team 2" class="team-logo">
                                            <div class="club-name mt-2">
                                                <span>
                                                    {{item.team2.name}}
                                                </span>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div class="match-details-footer text-center">
                                    <span class="match-date-location">
                                        {{item.data}} ÀS {{item.hora}}H - {{item.local}}
                                    </span>
                                </div>

                                <div class="button-finaly" (click)="goToRegister()">
                                  <button>GARANTA SEU LUGAR AGORA!</button>
                                </div>

                            </div>
                        </ng-container>
                    </div>

                    <a class="carousel-control-prev" href="#confronto" role="button" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#confronto" role="button" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
